/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_validation_password_min_length = /** @type {(inputs: { min: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Password must be at least ${i?.min} characters`)
};

const zh_hans1_settings_validation_password_min_length = /** @type {(inputs: { min: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`密码至少需要 ${i?.min} 个字符`)
};

const zh_hant1_settings_validation_password_min_length = /** @type {(inputs: { min: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`密碼至少需要 ${i?.min} 個字元`)
};

const fr_settings_validation_password_min_length = /** @type {(inputs: { min: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le mot de passe doit contenir au moins ${i?.min} caractères`)
};

const de_settings_validation_password_min_length = /** @type {(inputs: { min: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Passwort muss mindestens ${i?.min} Zeichen lang sein`)
};

const ja_settings_validation_password_min_length = /** @type {(inputs: { min: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`パスワードは ${i?.min} 文字以上である必要があります`)
};

const ko_settings_validation_password_min_length = /** @type {(inputs: { min: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`비밀번호는 최소 ${i?.min}자여야 합니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ min: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_validation_password_min_length = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_validation_password_min_length(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_validation_password_min_length", locale)
	if (locale === "en") return en_settings_validation_password_min_length(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_validation_password_min_length(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_validation_password_min_length(inputs)
	if (locale === "fr") return fr_settings_validation_password_min_length(inputs)
	if (locale === "de") return de_settings_validation_password_min_length(inputs)
	if (locale === "ja") return ja_settings_validation_password_min_length(inputs)
	return ko_settings_validation_password_min_length(inputs)
};